import { Component } from '@angular/core';
import { AppLoadService } from '@ebb-v2/ebb-integration';

@Component({
  selector: 'ebb-v2-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class ContractorSearchAppComponent {
  title = 'ebb-contractor-app-search';

  public genericLogo: any = null;
  public businessLogoRoot: any = null;

  constructor(
    private readonly apiAppSettings: AppLoadService
  ) {
    const envSettings = this.apiAppSettings.readEnvironSettings();

    this.genericLogo = `${envSettings.uriEbbAssets}/images/ContractorLogo.png`;
    this.businessLogoRoot = `${envSettings.uriApiRoot}/files/contractorLogo/`;
  }
}
